<template>
  <div class="leftnav">
    <el-card class="box-card w160">
       <el-menu
        router
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        @select="selectNav"
        >
        <div class="navList">
          <p>我的订单</p>
         <div class="lists">
            <el-menu-item index="/home/contentmain">
          <span slot="title">我的订单</span>
          </el-menu-item>
          <el-menu-item index="/home/main/favorites">
              <span slot="title">收藏夹</span>
          </el-menu-item>
          
          <!-- <el-menu-item index="/home/main/terminalorderlist">
              <span slot="title">终端要货清单</span>
          </el-menu-item> -->
          <el-menu-item index="/home/main/mydeliveryorder">
              <span slot="title">我的发货单</span>
          </el-menu-item>
           <el-menu-item index="/home/main/distributionorder">
              <span slot="title">分销订单</span>
          </el-menu-item>
          <el-menu-item index="/home/main/inventory">
              <span slot="title">经销商库存查看</span>
          </el-menu-item>
         </div>
        </div>
        <div class="navList mt20">
            <p>资金费用</p>
            <div class="lists">
              <!-- <el-menu-item index="/home/main/fundsituation">
                  <span slot="title">我的余额</span>
              </el-menu-item> -->
              <el-menu-item index="/home/main/customer">
                  <span slot="title">对账函</span>
              </el-menu-item>
              <el-menu-item index="/home/main/notify_letter">
                  <span slot="title">告知函</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/main/fundDetail">
                  <span slot="title">资金明细</span>
              </el-menu-item> -->
              <el-menu-item index="/home/main/discountDetail">
                  <span slot="title">返利&现金垫付明细</span>
              </el-menu-item>
              <el-menu-item index="/home/main/goodsDetail">
                  <span slot="title">货补明细</span>
              </el-menu-item>
              <el-menu-item index="/home/main/replenishmentdetails">
                  <span slot="title">任务查询</span>
              </el-menu-item>
           </div>
        </div>
        <div class="navList mt20">
            <p>客户互动</p>
            <div class="lists">
              <el-menu-item index="/home/main/announcement">
                  <span slot="title">公告查看</span>
              </el-menu-item>
              <el-menu-item index="/home/main/company">
                  <span slot="title">公司资料查看</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/main/contractManage">
                  <span slot="title">合同管理</span>
              </el-menu-item> -->
            </div>
        </div>
        <div class="navList mt20" style="border:0px;">
            <p>服务管理</p>
           <div class="lists" style="padding-bottom:0px!important;">
             <el-menu-item index="/home/main/changepass">
              <span slot="title">修改密码</span>
            </el-menu-item>
            <!-- <el-menu-item index="/home/main/system">
                <span slot="title">系统设置</span>
            </el-menu-item> -->
           </div>
        </div>
    </el-menu>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "leftnav",
  data() {
    return {
      activeIndex: ""
    };
  },
  // 检测路由变化
  watch: {
    $route() {
      this.setCurrentRoute();
    }
  },
  methods: {
    selectNav(e){//解决了重新加载组件颜色改变 但是体验不太好
      // setTimeout(()=>{
      //   location.reload()
      // },100)
    },
    /**
     * @description: 两个路由，在同一个菜单栏处高亮显示
     * @param {*}
     * @return {*}
     * @author: txp
     */
    setCurrentRoute() {
      if(this.$route.path == '/home/main/taskDetail'){  
        this.activeIndex= "/home/main/replenishmentdetails";
      }else if(this.$route.path=='/home/main/contractManageDet'){
        this.activeIndex =  "/home/main/contractManage"
      }else if(this.$route.path == '/home/main/terminallistdet'){
        this.activeIndex =  "/home/main/terminalorderlist"
      }else if(this.$route.path == '/home/main/reconletter'){
        this.activeIndex =  "/home/main/customer"
      }
      else{
        this.activeIndex= this.$route.path;
      }
    }
  },
  created(){
    this.setCurrentRoute();
  }
};
</script>

<style lang="scss">
    .leftnav{
      .el-menu{
        border: 0;
        .navList:not(last-child){
          border-bottom: 1px solid #EAEAEA;
          p{
            font-size: 18px;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
          }
          .lists{
            padding: 14px 0px!important;
          }
          .el-menu-item{
            line-height:30px;
            padding-left: 0px;
            font-size: 14px;
            height: 30px;
            padding: 0px!important;
          }
          .el-submenu__title{
              background-color:transparent!important;
            }
          .el-menu-item {
            background-color:transparent!important; 
          }
          .menuLeft .el-menu-item.is-active {
            font-weight: bold!important;
            background-color:transparent!important; 
          }
          .menuLeft .el-submenu__title.is-active {
            font-weight: bold!important;
            background-color:transparent!important; 
          }
        }
      }
      
    }
</style>
